// extracted by mini-css-extract-plugin
module.exports = {"price":"MenuItemPrice__price___QlP1d colors__text-dark___2vRHZ"};